import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { IconPipe } from 'common';
import { ButtonComponent } from 'ui-elements/button';
import { ModalComponent } from 'ui-elements/modal';
import { BaseModalComponent } from '../../base/base-modal.component';

export interface ModalConfirmData {
  headerTitle?: string;
  confirmMessage?: string;
  secondaryMessage?: string;
  confirmBtnLabel?: string;
  cancelBtnLabel?: string;
  modalWidth?: number;
  showAlertIcon?: boolean;
  cancelAsPrimaryOption?: boolean;
  allowEnter?: boolean;
}

@Component({
  imports: [ModalComponent, ButtonComponent, IconPipe],
  providers: [IconPipe],
  selector: 'ss-stx-shared-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalConfirmComponent extends BaseModalComponent<Object> {
  @Input() headerTitle?: string;
  @Input() confirmMessage?: string;
  @Input() secondaryMessage?: string;
  @Input() confirmBtnLabel?: string = 'CONFIRM';
  @Input() cancelBtnLabel = 'CANCEL';
  @Input() modalWidth = 50;
  @Input() showAlertIcon = false;
  @Input() allowEnter = false;
  @Output() confirm = new EventEmitter<boolean>();

  @Input() cancelAsPrimaryOption = false;

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.allowEnter && event.key === 'Enter') {
      this.onConfirm();
    }
  }

  onConfirm() {
    this.modalCloseClick(false);
    this.confirm.emit(true);
  }

  onCancel() {
    this.modalCloseClick(false);
    this.confirm.emit(false);
  }

  // Used by the modal service to set the options
  setOptions(options: ModalConfirmData) {
    this.headerTitle = options.headerTitle ?? this.headerTitle;
    this.confirmMessage = options.confirmMessage ?? this.confirmMessage;
    this.secondaryMessage = options.secondaryMessage ?? this.secondaryMessage;
    this.confirmBtnLabel = options.confirmBtnLabel ?? this.confirmBtnLabel;
    this.cancelBtnLabel = options.cancelBtnLabel ?? this.cancelBtnLabel;
    this.modalWidth = options.modalWidth ?? this.modalWidth;
    this.allowEnter = options.allowEnter ?? this.allowEnter;
    this.showAlertIcon = options.showAlertIcon ?? this.showAlertIcon;
    this.cancelAsPrimaryOption =
      options.cancelAsPrimaryOption ?? this.cancelAsPrimaryOption;
  }
}
